// DALL-E промпти для генерації тексту

export const greetingTextPrompts = (formData) => {
  const genderText = formData.gender === 'male' ? 'чоловічої' : formData.gender === 'female' ? 'жіночої' : 'не вказаної';

  return `Сформуй 5 коротких текстів привітання українською мовою для особи ${formData.age ? `${formData.age} років` : 'різного віку'}, ${genderText} статі, Ім'я ${formData.name || 'не вказано'}, ${formData.person || 'не вказано'}.

Контекст привітання: ${formData.greetingSubject || 'загальне привітання'}.

Атрибути та символи: ${formData.hobby || 'не вказано'}.

Риси та цінності: ${formData.trait || 'не вказано'}.

Настрій картки: ${formData.cardMood || 'позитивний'}.

Тексти мають бути:
- Персоналізованими та теплими
- Відповідати настрою
- Враховувати атрибути та риси особистості але без банальних порівнянь
- Різноманітними за довжиною та стилем
- Підходящими для листівки або картки
- БЕЗ використання слова "undefined" або заповнювачів
- Можна використовувати різні форми імені


Поверни відповідь у форматі JSON масиву з 5 елементів:
["текст привітання 1", "текст привітання 2", "текст привітання 3", "текст привітання 4", "текст привітання 5"]`;
}; 